import { render, staticRenderFns } from "./usersList.vue?vue&type=template&id=1086a356"
import script from "./usersList.vue?vue&type=script&lang=js"
export * from "./usersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports